import { VerticalStepper } from '@code/innovance-react-ui-kit';

import { ProgressProps } from '@code/innovance-react-ui-kit/dist/components/progress/Progress';
import { TFunction } from 'i18next';
import { BREAK_POINTS } from 'src/front/constant';
import styled from 'styled-components';

const getStepLabel = (
  currentIndex: number,
  stepsLength: number,
  t: TFunction,
  isCompleted?: boolean
): string => {
  return t('general_progressBar_text', {
    percentage: (((currentIndex + (isCompleted ? 1 : 0)) / stepsLength) * 100).toFixed(0),
  });
};
const getStepValue = (currentIndex: number, stepsLength: number, isCompleted?: boolean): number => {
  return ((currentIndex + (isCompleted ? 1 : 0)) / stepsLength) * 100;
};

export const getProgressConfig = (
  currentIndex: number,
  stepsLength: number,
  max: number,
  t: TFunction,
  isCompleted?: boolean
): ProgressProps => {
  return {
    max,
    label: getStepLabel(currentIndex, stepsLength, t, isCompleted),
    value: getStepValue(currentIndex, stepsLength, isCompleted),
  };
};

const Stepper = styled(VerticalStepper)`
  position: absolute;
  top: 0px;

  width: 280px;

  @media screen and (max-width: ${BREAK_POINTS.MAX.TABLET}) and (min-width: ${BREAK_POINTS.MIN
      .PHONE}) {
    width: 270px;
  }
`;
export default Stepper;
